jQuery(function ($) {
  const staffLocationsFadeTiming = 400;
  if ($(window).width() >= 1140) {
    $('.staff__locations__locations-link').hover(function () {
      if ($(this).hasClass('staff__locations__locations-link--active')) {
        $(this)
          .children('.staff__locations__locations-image--outside')
          .fadeIn(staffLocationsFadeTiming);
        $(this)
          .children('.staff__locations__locations-image--inside')
          .fadeOut(staffLocationsFadeTiming);
      } else {
        $(this)
          .children('.staff__locations__locations-image--outside')
          .fadeOut(staffLocationsFadeTiming);
        $(this)
          .children('.staff__locations__locations-image--inside')
          .fadeIn(staffLocationsFadeTiming);
      }
      $(this).toggleClass('staff__locations__locations-link--active');
    });
  }
  $('.staff__locations__locations-toggle-wrapper').on('click', function (e) {
    e.preventDefault();
    if (
      $(this)
        .parents('.staff__locations__locations-link')
        .hasClass('staff__locations__locations-link--active')
    ) {
      $(this)
        .parents('.staff__locations__locations-link')
        .children('.staff__locations__locations-image--outside')
        .fadeIn(staffLocationsFadeTiming);
      $(this)
        .parents('.staff__locations__locations-link')
        .children('.staff__locations__locations-image--inside')
        .fadeOut(staffLocationsFadeTiming);
      $(this).find('.staff__locations__locations-toggle-text-dynamic').text('Inside');
    } else {
      $(this)
        .parents('.staff__locations__locations-link')
        .children('.staff__locations__locations-image--outside')
        .fadeOut(staffLocationsFadeTiming);
      $(this)
        .parents('.staff__locations__locations-link')
        .children('.staff__locations__locations-image--inside')
        .fadeIn(staffLocationsFadeTiming);
      $(this).find('.staff__locations__locations-toggle-text-dynamic').text('Outside');
    }
    $(this)
      .parents('.staff__locations__locations-link')
      .toggleClass('staff__locations__locations-link--active');
  });
});
